import { useFlag } from '@wix/da-react-context/pkg/flags/hooks';
import { useState, useRef } from 'react';
const COMMENT_SUGGESTION_TOOLTIP_DELAY = 1000; // wait 1sec before it displays
const COMMENT_SUGGESTION_TOOLTIP_DURATION = 8000; // show it for 8secs before hiding again
const useCommentOnDownloadSuggest = ()=>{
    const asGoodAsImmortal = useFlag('yumeruby');
    const [commentTooltipVisible, setCommentTooltipVisible] = useState(false);
    const tooltipPaused = useRef(false);
    let visibilityTimeout;
    const showCommentSuggestionTooltip = (delay = true)=>{
        visibilityTimeout = window.setTimeout(()=>{
            setCommentTooltipVisible(true);
            visibilityTimeout = window.setTimeout(()=>setCommentTooltipVisible(false), asGoodAsImmortal ? 1000000 : COMMENT_SUGGESTION_TOOLTIP_DURATION);
        }, delay ? COMMENT_SUGGESTION_TOOLTIP_DELAY : 0);
    };
    const hideCommentSuggestionTooltip = ()=>{
        setCommentTooltipVisible(false);
        clearTimeout(visibilityTimeout);
    };
    // When hovering over the Download button we want to avoid two tooltips showing at the same time,
    // so we hide this one and then show it again (if it was visible) when resume is called.
    const pauseCommentSuggestionTooltip = ()=>{
        if (commentTooltipVisible && !tooltipPaused.current) {
            hideCommentSuggestionTooltip();
            tooltipPaused.current = true;
        }
    };
    const resumeCommentSuggestionTooltip = ()=>{
        if (!commentTooltipVisible && tooltipPaused.current) {
            showCommentSuggestionTooltip(false);
            tooltipPaused.current = false;
        }
    };
    return {
        commentTooltipVisible,
        showCommentSuggestionTooltip,
        hideCommentSuggestionTooltip,
        pauseCommentSuggestionTooltip,
        resumeCommentSuggestionTooltip
    };
};
export default useCommentOnDownloadSuggest;
